import React, { useState, useRef } from 'react';
import topics from '../../../menus/ClassOne/Measurement';
import { IonItem, IonLabel, IonRadio, IonRadioGroup } from '@ionic/react';

const Measurement: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    document.title = "Mamas Guidance - Class One - Mathematics - Measurement"; // Set page title

    return (
        <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};

export default Measurement;